import transitionPath, { nameToIDs } from './transitionPath';
import shouldUpdateNode from './shouldUpdateNode';

export { shouldUpdateNode, nameToIDs };

export default transitionPath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/router5-transition-path/dist/es/index.js
// module id = 65
// module chunks = 0